export default __webpack_public_path__ + "static/media/white_ticket.b0607705.svg";